var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$item, _vm$item2, _vm$item3, _vm$item3$authors, _vm$item4, _vm$item5;

        var hover = _ref.hover;
        return [_c('v-card', {
          staticClass: "test",
          staticStyle: {
            "overflow": "hidden"
          },
          attrs: {
            "color": "primary",
            "height": "100%",
            "width": "100%",
            "flat": "",
            "rounded": "lg"
          }
        }, [_vm.imgMissing && !hover ? _c('v-sheet', {
          staticClass: "secondary--text font-weight-bold text-body-2 py-1 pl-2 text-truncate",
          attrs: {
            "color": "transparent"
          }
        }, [_vm._v(" " + _vm._s(_vm.item.title))]) : _vm._e(), _c('img', {
          staticStyle: {
            "object-fit": "cover",
            "height": "100%",
            "width": "100%"
          },
          attrs: {
            "id": "t",
            "height": "100%",
            "width": "100%",
            "src": _vm.src
          },
          on: {
            "load": _vm.onImageLoad
          }
        }), _c('v-expand-transition', [_c('div', {
          staticClass: "overlay d-flex flex-column align-start justify-start transition-fast-in-fast-out primary v-card--reveal cursor-arrow pa-2",
          style: ("height: " + (_vm.allowHover && hover ? '100%' : '0%') + "; opacity: " + (_vm.allowHover && hover ? 1 : 0) + "; overflow-y: scroll")
        }, [_c('a', {
          staticClass: "secondary--text font-weight-bold text-body-1 mb-0",
          attrs: {
            "href": ((_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.catalogUrl) || '',
            "target": "_blank"
          }
        }, [_vm._v(" " + _vm._s(_vm.item.title) + " ")]), _c('p', {
          staticClass: "text-caption secondary--text"
        }, [_vm._v(" " + _vm._s(Array.isArray((_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.authors) ? (_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : (_vm$item3$authors = _vm$item3.authors) === null || _vm$item3$authors === void 0 ? void 0 : _vm$item3$authors[0] : ((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : _vm$item4.authors) || '') + " ")]), _c('p', {
          staticClass: "text-caption secondary--text",
          domProps: {
            "innerHTML": _vm._s(((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : _vm$item5.description) || '')
          }
        })])])], 1)];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }